<template>
  <div class="field-tab-content">
    <div class="jzliu-bi-fields-wrapper">
      <div class="areas-wrapper" v-for="(i, idx) in fieldsViewWrapper" :key="idx + 'h'"
        v-show="(i.alias === 'drill' && !!i.chooseFields.length) || i.alias !== 'drill'">
        <div class="field-area-wrapper">
          <div class="field-area-header">
            <div class="area-name">
              <i class="require-icon" v-show="i.isMust">*</i>
              <img v-if="i.alias === 'drill' && isDrillChart(selectItem)"
                style="cursor: pointer;margin-left: 4px;vertical-align: middle;display: inline-block;" width="13px"
                src="../../assets/img/drilling3.png" alt="">
              <span>{{ i.label }}</span>
            </div>
            <div>
              <span v-if="i.limitNum">{{ i.chooseFields.length }}&nbsp;/&nbsp;{{ i.limitNum }}&nbsp;</span>
              <!-- <i class="el-icon-setting"></i> -->
            </div>
          </div>
          <div class="field-area-body">
            <div class="blank-area-tip" v-if="!i.chooseFields.length && i.alias !== 'filter'">拖动数据字段至此处</div>
            <div class="blank-area-tip" @click="handleAddFilter"
              style="position: absolute;top:-5px;left: 50%;transform: translateX(-50%);z-index: 1000;"
              v-else-if="!i.chooseFields.length && i.alias === 'filter'">
              <el-button type="text" size="mini">{{filterLength > 0 ? '编辑过滤条件('+filterLength+')' :
                '设置过滤条件'}}</el-button>
            </div>
            <draggable :move="(e,i) => onMove(e,i)" @add="(e) => handleDragUpdate(e, i, idx)" filter=".blank-area-tip"
              :class="{ 'drag-warp': !i.chooseFields.length }" v-model="i.chooseFields" group="any" animation="300">
              <div class="sort-list-item drag-li" :key="`${v.id}_${idx}_${vIndex}_${i.queryType}`"
                v-for="(v, vIndex) in chooseFieldsHandler(i.chooseFields, idx)" :data-type="v.defineType">
                <div class="field-box-wrapper">
                  <div class="dimension-field-box"
                    :class="['any', 'measure'].includes(v.defineType) ? 'measure-border' : 'dimension-border'">
                    <div class="bi_dashboard_text_overflow" style="max-width: 118px;display: inline-block;">
                      <span :title="v.name">{{ v.name }}</span>
                      <span v-show="v.aggregatorType && i.alias !== 'filter'">({{ aggregatorMap[v.aggregatorType]
                        }})</span>
                    </div>
                    <div class="right-icon">
                      <i v-if="!(i.alias === 'drill' && vIndex === 0)" class="el-icon-s-tools"
                        @click="onFieldSetting(v)"></i>
                      <i class="el-icon-delete" @click="handleDeleteChooseFields(i, vIndex)"></i>
                      <el-tooltip :content="isDrillFieldsWids(v) ? '已开启钻取' : '钻取'" placement="top">
                        <img :class="{ 'jzliu-bi-drill-field-icon': isDrillFieldsWids(v) }"
                          v-if="(v.defineType === 'dimension' && i.alias !== 'drill' && isDrillChart(selectItem))"
                          @click="handleDrill(v, i)" style="cursor: pointer;margin-left: 4px;vertical-align: middle;"
                          width="10px"
                          :src="!drillFieldsWids.includes(v._wid) ? require('../../assets/img/drill2.png') : require('../../assets/img/drilling3.png')"
                          alt="">
                      </el-tooltip>
                      <el-tooltip v-if="!!v.sortType" :content="getSortTooltip(v.sortType)" placement="top">
                        <img
                          width="13px"
                          style="vertical-align: middle; display: inline-block;"
                          :src="getSortIcon(v.sortType)"
                          alt=""
                        >
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <div class="update-wrapper" v-show="!!selectItem.name">
      <div class="guid-tip-container">
        <el-button type="primary" @click="handleUpdateDashboard">更新</el-button>
      </div>
    </div>
    <el-dialog append-to-body :visible.sync="settingVisible" title="字段设置" width="580px" :show-close="false"
      :close-on-click-modal="false" custom-class="jzliu-bi-field-setting-dialog">
      <div class="jzliu-bi-field-setting-content" v-loading="loading">
        <!-- 字段原名 -->
        <div class="jzliu-bi-field-item">
          <div class="jzliu-bi-field-label">字段原名</div>
          <div class="jzliu-bi-field-original-name bi_dashboard_text_overflow" :title="currentField.unitName">{{
            currentField.unitName }}</div>
        </div>

        <!-- 显示名称 -->
        <div class="jzliu-bi-field-item">
          <div class="jzliu-bi-field-label">显示名称</div>
          <el-input v-model="fieldDisplayName" placeholder="请输入内容" size="small" class="jzliu-bi-field-input" />
        </div>

        <!-- 排序 -->
        <div class="jzliu-bi-field-item">
          <div class="jzliu-bi-field-label">排序</div>
          <div class="jzliu-bi-sort-options">
            <el-radio-group v-model="fieldSortType" size="small">
              <el-radio v-for="option in sortOptionList" :key="option.value || 'default'" :label="option.value">
                {{ option.label }}
              </el-radio>
            </el-radio-group>
          </div>
          <div class="jzliu-bi-field-custom-sort" v-if="fieldSortType === 'custom'">
            <div class="jzliu-bi-field-custom-sort-warp" @click="openCustomSortDialog">
              <div class="jzliu-bi-field-custom-sort-text" :class="{ 'is-placeholder': !hasCustomSort }"
                :title="customSortDisplayTextFull">{{ customSortDisplayText }}</div>
              <i class="el-icon-edit"></i>
            </div>
          </div>
        </div>
        <div class="jzliu-bi-field-item" v-if="currentField.alias === 'measure'">
          <div class="jzliu-bi-field-label">计算方式</div>
          <div class="jzliu-bi-sort-options">
            <el-select style="width:100%" v-model="fieldCalculateType" size="small">
              <el-option v-for="item in listView" :key="item.type" :label="item.name" :value="item.type"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div slot="footer" class="jzliu-bi-dialog-footer">
        <div>
          <el-button size="small" @click="cancelFieldSetting">取消</el-button>
        </div>
        <div>
          <el-button type="primary" size="small" @click="confirmFieldSetting">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog append-to-body :visible.sync="filterSettingDialogVisible" title="过滤条件" width="80%">
      <filter-tpl-pro :checkStrictly="true" :showAllLevel="false" fieldGroupName="custom"
        v-if="filterSettingDialogVisible" ref="filterTplPro" v-model="filterList" :fields="fieldsView"
        :negated.sync="selectItem.filterObj.filterParentNegated" customName="chart-filter"
        :customProps="{ checkStrictly:true }"></filter-tpl-pro>
      <div slot="footer" class="jzliu-bi-dialog-footer">
        <div>
          <el-button size="small" @click="cancelFilterSetting">取消</el-button>
        </div>
        <div>
          <el-button type="primary" size="small" @click="confirmFilterSetting">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 自定义排序弹框 -->
    <el-dialog append-to-body :visible.sync="customSortDialogVisible" title="自定义排序" width="363px" :show-close="false"
      :close-on-click-modal="false" custom-class="jzliu-bi-custom-sort-dialog">
      <div class="jzliu-bi-custom-sort-content">
        <div class="jzliu-bi-custom-sort-table">
          <div class="jzliu-bi-custom-sort-table-header">
            <div class="jzliu-bi-custom-sort-table-cell" style="flex: 1;">维度值</div>
            <div class="jzliu-bi-custom-sort-table-cell" style="width: 55px;">操作</div>
          </div>
          <draggable v-model="customSortList" :animation="200" :disabled="false">
            <div class="jzliu-bi-custom-sort-table-row" v-for="(item, index) in customSortList"
              :key="item.value || index">
              <div class="jzliu-bi-custom-sort-table-cell" style="flex: 1;">
                <div class="jzliu-bi-custom-sort-value">{{ item.value }}</div>
              </div>
              <div class="jzliu-bi-custom-sort-table-cell" style="width: 55px;">
                <el-dropdown trigger="click" @command="(cmd) => handleSortCommand(cmd, index)">
                  <span class="jzliu-bi-custom-sort-menu-icon">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 2H13M1 7H13M1 12H13" stroke="#165DFF" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="'moveUp'">上移</el-dropdown-item>
                    <el-dropdown-item :command="'moveDown'">下移</el-dropdown-item>
                    <el-dropdown-item :command="'moveTop'">置顶</el-dropdown-item>
                    <el-dropdown-item :command="'moveBottom'">置底</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </draggable>
        </div>
      </div>
      <div slot="footer" class="jzliu-bi-custom-sort-footer">
        <el-button size="small" @click="closeCustomSortDialog">取消</el-button>
        <el-button type="primary" size="small" @click="confirmCustomSort">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import cDropdown from '../base/cDropdown'
import { aggregatorMap } from '../../utils/enum.data'
import { updateChartDataHelper } from '../../utils/index'
import filterTplPro from '../base/filterTplPro/index.vue'
import { defaultFilterObj, defaultDrillField, isDrillChart, isHasDrill } from '../../utils/panelConf'
import { isCustomSortOrderWidget } from '../../utils/utils'
import sortIconCustom from '../../assets/img/sx.png'
import sortIconDesc from '../../assets/img/jx.png'
import sortIconAsc from '../../assets/img/zdy.png'

const sortOptionEnum = {
  NONE: '',
  ASC: 'asc',
  DESC: 'desc',
  CUSTOM: 'custom',
}

const sortTooltipMap = {
  [sortOptionEnum.CUSTOM]: '自定义',
  [sortOptionEnum.DESC]: '降序',
  [sortOptionEnum.ASC]: '升序',
}

const sortIconMap = {
  [sortOptionEnum.CUSTOM]: sortIconCustom,
  [sortOptionEnum.DESC]: sortIconDesc,
  [sortOptionEnum.ASC]: sortIconAsc,
}
import { widgetTypeMap } from '../../utils/enum.data'
import { P } from '@antv/g2plot'
export default {
  name: 'fieldTab',
  components: { draggable, cDropdown, filterTplPro },
  props: {
    getDwsData: {
      type: Function,
      default: () => Promise.resolve([])
    },
    fields: {
      type: Array,
      default: () => []
    },
    custom_updateData: {
      type: Function | Object,
      default: null,
    },
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      sortOptionEnum,
      widgetTypeMap,
      isCustomSortOrderWidget,
      isDrillChart,
      isHasDrill,
      filterList: [],
      listView: [],
      loading: false,
      settingVisible: false,
      filterSettingDialogVisible: false,
      customSortDialogVisible: false,
      currentField: {},
      aggregatorMap,
      fieldDisplayName: '',
      fieldSortType: '',
      fieldCalculateType: '',
      customSortList: [],
      originalCustomSortList: []
    }
  },
  computed: {
    showCustomSort() {
      console.log('this.selectItem.type:', this.currentField)
      return ['dimension'].includes(this.currentField.defineType)
        && isCustomSortOrderWidget(this.selectItem)
    },
    sortOptionList() {
      const baseOptions = [
        { value: sortOptionEnum.NONE, label: '不排序' },
        { value: sortOptionEnum.ASC, label: '升序' },
        { value: sortOptionEnum.DESC, label: '降序' },
      ]
      if (this.showCustomSort) {
        baseOptions.push({ value: sortOptionEnum.CUSTOM, label: '自定义' })
      }
      return baseOptions
    },
    filterLength() {
      return this.selectItem.filterObj?.filterList?.length ?? 0
    },
    drillFieldsWids() {
      // const isHasDrill = this.fields.some(f => f.alias === 'drill')
      // if (!isHasDrill) {
      //   this.fields.unshift(defaultDrillField())
      // }
      return this.fields.find(f => f.alias === 'drill')?.chooseFields?.map(f => f._wid) || []
    },
    fieldsViewWrapper() {
      this.fields.forEach(f => {
        if (f.alias !== 'filter' && f.chooseFields && f.chooseFields.length > 0) {
          f.chooseFields.forEach(v => {
            if (!v.children?.length) {
              v._wid = v.dimFieldWid || v.wid
            } else {
              v.children.forEach(c => {
                c._wid = c.dimFieldWid || c.wid
              })
            }
          })
        }
      })
      return this.fields.filter(f => !!f)
    },
    fieldsView() {
      /****
 * 内部传入的字段格式需遵循
 * @params fieldName 字段中文名
 * @params field 字段物理名
 * @params fieldId 字段id
 * @params fieldType 英文字段类型
 * @params fieldTypeCn 中文字段类型
 * @params groupName 分组需要的字段
 * @params groupId 分组需要的字段
 * @params tableName 字段关联的表名
 * **/
      const formatField = (t) => {
        const attrs = t.attrs ?? {}
        const formatted = {
          fieldName: t.unitName,
          field: t.unitCode,
          fieldId: t.unitCode,
          ...attrs,
          isDimField: t.isDimField,
          dimTableWid: t.dimTableWid,
          dimFieldWid: t.dimFieldWid,
        }
        // 如果有children，递归格式化children
        if (t.children && Array.isArray(t.children) && t.children.length > 0) {
          formatted.children = t.children.map(child => formatField(child))
        }
        return formatted
      }
      const fields = JSON.parse(JSON.stringify([...this.selectItem.measures, ...this.selectItem.dimensions]))
      return fields.map(t => formatField(t))
    },
    chooseFieldsHandler() {
      return (list, idx) => {
        list.forEach((v) => {
          v.originIdx = 'originIdx' in v ? v.originIdx : idx
        })
        return list
      }
    },
    customSortDisplayText() {
      // 如果有自定义排序，显示自定义排序的值
      if (this.currentField.customSortOrder && this.currentField.customSortOrder.length > 0) {
        return this.currentField.customSortOrder.join('、')
      }
      // 否则显示正常顺序的所有值
      return this.getDefaultSortValues().join('、')
    },
    customSortDisplayTextFull() {
      // 如果有自定义排序，返回自定义排序的值
      if (this.currentField.customSortOrder && this.currentField.customSortOrder.length > 0) {
        return this.currentField.customSortOrder.join('、')
      }
      // 否则返回正常顺序的所有值
      return this.getDefaultSortValues().join('、')
    },
    hasCustomSort() {
      // 判断是否已设置自定义排序
      return this.currentField.customSortOrder && this.currentField.customSortOrder.length > 0
    }
  },
  watch: {
    'selectItem.fields': {
      handler(newFields, oldFields) {
        // 确保 fields 有 chooseFields 属性
        if (newFields && newFields.length > 0) {
          newFields.forEach(field => {
            if (!field.chooseFields) {
              this.$set(field, 'chooseFields', [])
            }
          })
        }
        const drillFields = newFields?.find(f => f.alias === 'drill')
        drillFields?.chooseFields?.forEach(f => {
          f.alias = 'drill'
          f.queryType = 'drill'
        })
        // 强制更新组件
        this.$forceUpdate()
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    for (let i in aggregatorMap) {
      this.listView.push({ name: aggregatorMap[i], type: i })
    }
  },
  methods: {
    getSortTooltip(sortType) {
      return sortTooltipMap[sortType] || ''
    },
    getSortIcon(sortType) {
      return sortIconMap[sortType] || sortIconAsc
    },
    isDrillFieldsWids(v){
      return this.drillFieldsWids.includes(v._wid)
    },
    handleAddFilter() {
      if (!this.selectItem.filterObj) {
        this.filterObj = defaultFilterObj()
        this.$set(this.selectItem, 'filterObj', defaultFilterObj())
      }
      this.filterList = JSON.parse(JSON.stringify(this.selectItem.filterObj.filterList))
      this.filterSettingDialogVisible = true
    },
    onMove(e) {
      const { relatedContext, draggedContext } = e;
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      // 如果拖拽的元素是 fixed，不允许移动
      if (draggedElement.fixed) {
        return false;
      }

      // 如果目标位置是 fixed 元素，不允许插入到它前面
      if (relatedElement && relatedElement.fixed) {
        return false;
      }

      return true;
    },
    handleDrill(field, fieldItem) {
      field.fixed = true
      const idx = this.selectItem.fields.findIndex(i => i.alias === 'drill')
      this.$set(this.selectItem.fields[idx], 'chooseFields', [field])

      // 对当前字段列表进行排序
      const currentFieldList = this.selectItem.fields.find(f => f.alias === fieldItem.alias)
      if (currentFieldList) {
        this.$set(currentFieldList, 'chooseFields', this.sortFieldsByFixed(currentFieldList.chooseFields))
      }
    },
    confirmFilterSetting() {
      this.filterList = this.selectItem.filterObj.filterList = this.$refs.filterTplPro.filters
      this.filterSettingDialogVisible = false
    },
    cancelFilterSetting() {
      this.filterSettingDialogVisible = false
    },
    // 删除图表选中字段
    handleDeleteChooseFields(list, idx) {
      // 1、如果删除的是钻取的第一个字段，则清空所有的钻取维度
      if (list.alias === 'drill' && idx === 0) {
        list.chooseFields = []
      } else if (list.alias === 'dimension') {
        const drillFields = this.selectItem.fields.find(f => f.alias === 'drill')
        if (drillFields?.chooseFields?.[0]?._wid === list.chooseFields[idx]?._wid) {
          drillFields.chooseFields = []
        }
      }
      list.chooseFields.splice(idx, 1)
      if (list.alias === 'drill' && list.chooseFields.length > 0) {
        list.chooseFields[0].fixed = true
      }
    },
    // 字段设置
    async onFieldSetting(field) {
      this.currentField = field
      this.fieldDisplayName = field.name || field.unitName
      this.fieldSortType = field.sortType || ''
      this.fieldCalculateType = field.aggregatorType || ''
      if (!this.selectItem.filterObj) {
        this.filterObj = defaultFilterObj()
        this.$set(this.selectItem, 'filterObj', defaultFilterObj())
      }
      if (field.alias === 'filter') {
        this.filterList = this.selectItem.filterObj.filterList
        this.filterSettingDialogVisible = true
      } else {
        this.settingVisible = true
        if (!this.selectItem.dwsData?.length) {
          this.loading = true
          const data = await this.getDwsData()
          this.selectItem.dwsData = data ?? []
          this.loading = false
        }
      }
    },
    // 取消字段设置
    cancelFieldSetting() {
      this.settingVisible = false
      this.fieldDisplayName = ''
      this.fieldSortType = ''
      this.fieldCalculateType = ''
    },
    // 确认字段设置
    confirmFieldSetting() {
      // 更新字段的显示名称和排序类型
      this.$set(this.currentField, 'name', this.fieldDisplayName)
      this.$set(this.currentField, 'sortType', this.fieldSortType)
      this.$set(this.currentField, 'aggregatorType', this.fieldCalculateType)
      console.log('this.currentField:', this.currentField)
      this.settingVisible = false

      // 触发父组件更新
      this.$emit('field-updated', this.currentField)
    },
    // 获取默认的正常顺序值
    getDefaultSortValues() {
      // 获取默认的正常顺序值
      const fieldCode = this.currentField.unitCode
      const dwsData = this.selectItem.dwsData || []
      
      // 提取该字段的所有唯一值
      const uniqueValues = new Set()
      dwsData.forEach(item => {
        if (item[fieldCode] !== null && item[fieldCode] !== undefined && item[fieldCode] !== '') {
          uniqueValues.add(String(item[fieldCode]))
        }
      })
      
      // 返回排序后的数组（正常顺序）
      return Array.from(uniqueValues).sort()
    },
    // 打开自定义排序弹框
    openCustomSortDialog() {
      // 从图表数据中获取当前字段的唯一值
      const fieldCode = this.currentField.unitCode
      const dwsData = this.selectItem.dwsData || []
      
      // 提取该字段的所有唯一值
      const uniqueValues = new Set()
      dwsData.forEach(item => {
        if (item[fieldCode] !== null && item[fieldCode] !== undefined && item[fieldCode] !== '') {
          uniqueValues.add(String(item[fieldCode]))
        }
      })
      
      // 获取已有的自定义排序顺序，如果为空则使用默认排序
      let existingOrder = this.currentField.customSortOrder || []
      if (!existingOrder || existingOrder.length === 0) {
        // 如果 customSortOrder 为空，初始化为默认排序
        existingOrder = Array.from(uniqueValues).sort()
        this.$set(this.currentField, 'customSortOrder', existingOrder)
      }
      
      // 构建排序列表（确保顺序与 getDefaultSortValues 一致）
      const allValues = Array.from(uniqueValues).sort()
      const sortedValues = []
      const unsortedValues = []
      
      // 先添加已有排序的值
      existingOrder.forEach(value => {
        if (allValues.includes(value)) {
          sortedValues.push({ value, original: value })
        }
      })
      
      // 再添加未排序的值（按字母顺序）
      allValues.forEach(value => {
        if (!existingOrder.includes(value)) {
          unsortedValues.push({ value, original: value })
        }
      })
      
      this.customSortList = [...sortedValues, ...unsortedValues]
      this.originalCustomSortList = JSON.parse(JSON.stringify(this.customSortList))
      this.customSortDialogVisible = true
    },
    // 关闭自定义排序弹框
    closeCustomSortDialog() {
      this.customSortDialogVisible = false
      // 恢复原始列表
      this.customSortList = JSON.parse(JSON.stringify(this.originalCustomSortList))
    },
    // 确认自定义排序
    confirmCustomSort() {
      // 保存排序顺序
      const sortOrder = this.customSortList.map(item => item.value)
      this.$set(this.currentField, 'customSortOrder', sortOrder)
      this.customSortDialogVisible = false
    },
    // 处理排序操作命令
    handleSortCommand(command, index) {
      const action = command
      const list = this.customSortList
      
      switch (action) {
        case 'moveUp':
          if (index > 0) {
            const temp = list[index]
            this.$set(list, index, list[index - 1])
            this.$set(list, index - 1, temp)
          }
          break
        case 'moveDown':
          if (index < list.length - 1) {
            const temp = list[index]
            this.$set(list, index, list[index + 1])
            this.$set(list, index + 1, temp)
          }
          break
        case 'moveTop':
          if (index > 0) {
            const item = list.splice(index, 1)[0]
            list.unshift(item)
          }
          break
        case 'moveBottom':
          if (index < list.length - 1) {
            const item = list.splice(index, 1)[0]
            list.push(item)
          }
          break
      }
    },
    // 通用排序方法 - 将 fixed: true 的元素排在第一位
    sortFieldsByFixed(fields) {
      return fields.sort((a, b) => {
        // 如果 a 是 fixed，b 不是，a 排在前面
        if (a.fixed && !b.fixed) return -1
        // 如果 b 是 fixed，a 不是，b 排在前面
        if (!a.fixed && b.fixed) return 1
        // 如果都是 fixed 或都不是 fixed，保持原有顺序
        return 0
      })
    },
    // 拖拽更新
    handleDragUpdate(e1, field, idx) {
      const updateFields = (list) => {
        // 对列表进行排序，fixed: true 的元素排在第一位
        const sortedList = this.sortFieldsByFixed(list)
        this.fields[idx].chooseFields = sortedList
      }
      this.$nextTick(() => {
        const { chooseFields: list, type, alias, queryType, defineType } = field
        const listClone = JSON.parse(JSON.stringify(list))
        const index = e1.newIndex < 0 ? 0 : e1.newIndex
        const oldIdx = e1.oldIndex < 0 ? 0 : e1.oldIndex
        const isHasChild = !!e1.from?.getAttribute('data-type')
        let cur = list[index]
        if (!cur) return
        // 这里需要考虑两个可能来源 1是从数据维度和度量拖拽来的 2是从当前字段内部进行拖拽
        let fromType = e1.from?.getAttribute('data-type') ?? cur.defineType
        if(alias === 'filter') {
          list.splice(index, 1)
          return
        }
        if (type !== 'any' && fromType !== type) {
          list.splice(index, 1)
          if (!isHasChild) {
            // 如果是从当前字段内部拖拽 格式不正确去要重置到原数组fields中
            this.$set(this.fields[cur.originIdx]['chooseFields'], oldIdx, cur)
          }
          this.$message.warning('该类型字段不可以拖入～')
          return
        }
        // 如果来源不是当前字段集 需要更新originIdx来源索引字段
        if (!isHasChild) {
          cur.originIdx = idx
        }
        listClone[index].aggregatorType = fromType !== 'dimension' ? 'sum' : ''
        listClone[index].defineType = fromType
        listClone[index].originType = type
        listClone[index].alias = alias
        listClone[index].queryType = queryType
        listClone.forEach((v, i) => {
          v.id = `${v.unitCode}_${i}`
        })
        updateFields(listClone)
        let num = 0
        list.forEach((v) => {
          if (v.unitCode === cur.unitCode) {
            num++
          }
        })
        // 如果是交叉表等这种可以维度和度量混合拖动的图表还需要考虑度量必须在同一轴上这种可能
        if (fromType === 'measure') {
          const measureLives = []
          this.fields.forEach((v) => {
            let findMeasureItem = v.chooseFields.find(
              (f) => f.defineType === 'measure' && ['measure', 'dimension'].includes(f.defineType) && f.alias !== 'filter'
            )
            if (findMeasureItem) {
              measureLives.push(findMeasureItem)
            }
          })
          if (measureLives.length > 1) {
            listClone.splice(index, 1)
            updateFields(listClone)
            return this.$message.warning('度量必须在同一轴上')
          }
        }
        // 如果是维度和度量都可以拖放的字段(排除过滤器) 需要校验维度必须在上度量在下且不可以穿插
        if (type === 'any' && alias === 'measure') {
          const firstMeasureIndex = list.findIndex((v) => v.defineType === 'measure')
          const firstDimensionIndex = list.findIndex((v) => v.defineType === 'dimension')
          if (
            (fromType === 'dimension' && index >= firstMeasureIndex && firstMeasureIndex > -1) ||
            (fromType === 'measure' && index <= firstDimensionIndex && firstDimensionIndex > -1)
          ) {
            listClone.splice(index, 1)
            updateFields(listClone)
            return this.$message.warning('维度字段必须在度量字段上方～')
          }
        }
        // 如果该图表字段list的field包含两个维度 需要对插入字段进行重复判断 一个字段只能插入一个维度field
        const dimensionFields = this.fields.filter((v) => v.type === 'dimension')
        const curdIdNumMap = {}
        dimensionFields.forEach((v) => {
          if (!curdIdNumMap.hasOwnProperty(v.alias)) {
            curdIdNumMap[v.alias] = 0
          }
          v.chooseFields.forEach((s) => {
            if (s.unitCode === cur.unitCode) {
              curdIdNumMap[v.alias]++
            }
          })
        })
        if (curdIdNumMap[field.alias] > 1) {
          listClone.splice(index, 1)
          updateFields(listClone)
          return this.$message.warning(`已存在该对象 ${cur.unitName}`)
        }
        // 如果是列表类型，拖过来的字段的defineType如果是dimension，那么在行/维度和列/维度/度量中只能出现一次，并给出提示
        if (this.selectItem.type === widgetTypeMap.Table) {
          const dimUnitCodes = dimensionFields.find(t => t.alias === 'dimension')?.chooseFields.map(t => t.unitCode)
          if (dimUnitCodes.includes(cur.unitCode)) {
            listClone.splice(index, 1)
            updateFields(listClone)
            return this.$message.warning(`已存在该对象 ${cur.unitName}`)
          }
          console.log('dimensionFields===:', dimensionFields, cur)
        }
        // 字段本身数量限制
        const numValidate = list.length <= field.limitNum || !field.limitNum
        // 如果超过该字段本身设定的数量范围需要删除
        if (type !== 'any' && numValidate && num <= 1) {
          return
        }
        // 如果是度量 在不超过该字段本身设定的数量范围内是可以添加多个的
        if (['any', 'measure'].includes(type) && numValidate) {
          return
        }
        listClone.splice(index, 1)
        updateFields(listClone)
      })
    },
    // 更新仪表板
    async handleUpdateDashboard() {
      let validateMustSelectFlag = this.fields.find((v) => v.isMust && !v.chooseFields.length)
      if (validateMustSelectFlag) {
        return this.$message.warning(`${validateMustSelectFlag.label}缺少必填字段`)
      }
      this.updateChartData(this.selectItem)
    },
    async updateChartData(selectItem) {
       selectItem.styleConfig.commongConfig.pagination && selectItem.queryList && (selectItem.queryList.current = 1)
      this.$emit('on-update-single-chart')
      updateChartDataHelper(selectItem, this, this.custom_updateData)
    }
  }
}
</script>
<style scoped lang="less">
/deep/ .el-dialog__body {
  padding: 15px 20px
}

.field-tab-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: auto;

  .update-wrapper {
    flex: 1;
    position: relative;

    .guid-tip-container {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }

  .jzliu-bi-fields-wrapper {
    height: calc(100% - 40px);
    overflow-y: auto;
  }

  .areas-wrapper {

    .field-area-wrapper {
      overflow: hidden;
      font-size: 12px;
      color: var(--bi-jz-font-color);
      padding: 8px 12px;
      border-bottom: 1px solid var(--bi-jz-border-color);
      position: relative;

      .field-area-header {
        display: flex;
        justify-content: space-between;
        margin: 4px 0 8px;
        align-items: center;
      }

      .field-area-body {
        position: relative;
        margin: 4px 0;
        background: var(--bi-jz-input-bg-color);
        border: 1px dashed var(--bi-jz-border-color);
        transition: height 0.3s ease;
        min-height: 28px;
        border-radius: 2px;

        .drag-warp {
          min-height: 28px;
          position: absolute;
          top: 0;
        }

        .sort-list-item {
          margin: 8px;
        }

        .field-box-wrapper {
          display: flex;
          align-items: center;
          margin: 1px;
          font-size: 12px;
          height: 24px;
          position: relative;

          .dimension-field-box {
            flex: 1;
            height: 24px;
            line-height: 24px;
            background-color: rgba(46, 116, 255, 0.15);
            display: flex;
            padding: 0 8px;
            justify-content: space-between;

            .right-icon {
              cursor: pointer;

              i,
              img {
                display: none;
              }
            }

            &:hover {
              .right-icon {

                i,
                img {
                  display: inline-block;
                }

                color: var(--bi-jz-font-color);

                i:first-child {
                  display: inline-block;
                  margin-right: 6px;
                }
              }
            }
          }

          .dimension-border {
            border: 1px solid #2e74ff;
          }

          .measure-border {
            border: 1px solid #26bf59;
          }
        }

        .blank-area-tip {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          color: var(--bi-jz-font-color);
          padding: 4px 0;
        }
      }
    }
  }
}

// 字段设置弹框样式
:deep(.jzliu-bi-field-setting-dialog) {
  .el-dialog {
    width: 280px;
    margin: 0 auto;
    margin-top: 15vh;
  }

  .el-dialog__header {
    padding: 12px 16px 0;
    border-bottom: none;
  }

  .el-dialog__body {
    padding: 12px 16px;
  }

  .el-dialog__footer {
    padding: 0 16px 12px;
    text-align: right;
  }
}

// 自定义排序弹框样式
:deep(.jzliu-bi-custom-sort-dialog) {
  .el-dialog {
    width: 363px;
    margin: 0 auto;
    margin-top: 15vh;
    border-radius: 2px;
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0;
  }
}

.jzliu-bi-custom-sort-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid #EDEFF2;
  height: 48px;
  box-sizing: border-box;

  .jzliu-bi-custom-sort-title {
    font-family: 'Alibaba PuHuiTi 3.0', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    color: #1D212A;
  }

  .jzliu-bi-custom-sort-close {
    width: 14px;
    height: 14px;
    cursor: pointer;
    color: #9A9DA2;
    font-size: 14px;

    &:hover {
      color: #4E5969;
    }
  }
}

.jzliu-bi-custom-sort-content {
  min-height: 240px;
  max-height: 400px;
  overflow-y: auto;
}

.jzliu-bi-custom-sort-table {
  .jzliu-bi-custom-sort-table-header {
    display: flex;
    background: #F7F8FA;
    border-bottom: 1px solid transparent;
    height: 40px;
    align-items: center;

    .jzliu-bi-custom-sort-table-cell {
      padding: 10px;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      color: #4E5969;
    }
  }

  .jzliu-bi-custom-sort-table-row {
    display: flex;
    background: #FFFFFF;
    border-bottom: 1px solid #EDEFF2;
    height: 40px;
    align-items: center;
    cursor: move;

    &:hover {
      background: #F7F8FA;
    }

    .jzliu-bi-custom-sort-table-cell {
      padding: 10px;
      display: flex;
      align-items: center;

      .jzliu-bi-custom-sort-value {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        color: #1D2129;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 180px;
      }

      .jzliu-bi-custom-sort-menu-icon {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 14px;
        height: 14px;
        padding: 0;

        svg {
          width: 14px;
          height: 14px;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}

.jzliu-bi-custom-sort-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid #EDEFF2;
  gap: 12px;

  .el-button {
    padding: 5px 12px;
    height: 28px;
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;

    &.el-button--small {
      padding: 5px 12px;
    }
  }
}

.jzliu-bi-field-setting-content {
  .jzliu-bi-field-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .jzliu-bi-field-label {
    font-size: 12px;
    color: #3D3D3D;
    margin-bottom: 2px;
    line-height: 20px;
  }

  .jzliu-bi-field-original-name {
    font-size: 14px;
    color: #1D2129;
    line-height: 22px;
    padding: 5px 12px;
    background: #F7F8FA;
    border: 1px solid #DFE2E8;
    border-radius: 2px;
    height: 32px;
    display: flex;
    align-items: center;
  }

  .jzliu-bi-field-input {
    :deep(.el-input__inner) {
      height: 32px;
      line-height: 32px;
      border: 1px solid #DFE2E8;
      border-radius: 2px;
      font-size: 14px;
      color: #1D2129;

      &::placeholder {
        color: #C9CDD4;
      }
    }
  }

  .jzliu-bi-sort-options {
    :deep(.el-radio-group) {
      display: flex;
      gap: 20px;
    }

    :deep(.el-radio) {
      margin-right: 0;

      .el-radio__label {
        font-size: 14px;
        color: #1D2129;
        line-height: 22px;
      }

      .el-radio__input {
        .el-radio__inner {
          width: 14px;
          height: 14px;
          border: 1px solid #DFE2E8;
          background: #FFFFFF;

          &::after {
            width: 8px;
            height: 8px;
            background-color: #165DFF;
          }
        }

        &.is-checked .el-radio__inner {
          border-color: #165DFF;
          background: #FFFFFF;
        }
      }
    }
  }
}

.jzliu-bi-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  .el-button {
    height: 24px;
    padding: 2px 12px;
    font-size: 12px;
    border-radius: 2px;

    &.el-button--default {
      background: #FFFFFF;
      border: 1px solid #DFE2E8;
      color: #1D2129;
    }

    &.el-button--primary {
      background: #165DFF;
      border: 1px solid #165DFF;
      color: #FFFFFF;
    }
  }
}

.jzliu-bi-drill-field-icon {
  display: inline-block !important;
}

.jzliu-bi-field-custom-sort {
  margin-top: 6px;
  .jzliu-bi-field-custom-sort-warp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    width: 100%;
    background: #fff;
    border: 1px solid #DFE2E8;
    border-radius: 4px;
    font-size: 14px;
    color: #1D2129;
    padding: 5px 12px;
    
    .jzliu-bi-field-custom-sort-text {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 8px;
      cursor: pointer;
      
      &.is-placeholder {
        color: var(--color-primary, #2e74ff);
      }
    }

    i {
      color: var(--color-primary);
      cursor: pointer;
    }
  }
}
</style>
